import {defineComponent} from "vue"

export default defineComponent({
  data() {
    return {
      dialogs: {},
      dialogKeys: {}
    }
  },
  methods: {
    openDialog(key: string) {
      this.dialogs[key] = true
      if (!this.dialogKeys[key]) {
        this.dialogKeys[key] = 1
      } else {
        this.dialogKeys[key]++
      }
    },
    closeDialog(key: string) {
      this.dialogs[key] = false
    }
  }
})
